import styled from 'styled-components';

const DataTable = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;

  table {
    min-width: 100%;
  }
`;

export { DataTable };
